import React, { createContext, useContext, useState } from "react";

import type { ModuleType } from "@/types/zoho.types";

type RecordDetailsPanelContextType = {
    show: boolean;
    open: (recordId: string, moduleType?: ModuleType) => void;
    close: () => void;
    recordId: string | null;
    moduleType: ModuleType;
};

const RecordDetailsPanelContext = createContext<RecordDetailsPanelContextType | undefined>(undefined);

export const RecordDetailsPanelProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [show, setShow] = useState(false);
    const [recordId, setRecordId] = useState<string | null>(null);
    const [moduleType, setModuleType] = useState<ModuleType>("Leads");

    const open = (id: string, mod: ModuleType = "Leads") => {
        setRecordId(id);
        setModuleType(mod);
        setShow(true);
    };
    const close = () => setShow(false);

    return (
        <RecordDetailsPanelContext.Provider value={{ show, open, close, recordId, moduleType }}>
            {children}
        </RecordDetailsPanelContext.Provider>
    );
};

export const useRecordDetailsPanel = () => {
    return useContext(RecordDetailsPanelContext);
};
